import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { cloudAxios as axios } from './Authentication';
import { SetTarif } from '../models/Tariff';
export default {
  // GET

  /**
   * Get current user tariff
   *
   * @returns {AxiosPromise<any>}
   */
  getTariff(subdomain: string) {
    return axios().request({
        url: URLS().cloudUrlGetTariff + '/' + subdomain,
        method: 'get'
      });
  },

  // POST

  /**
   * Set current user tariff
   *
   * @param {*} data
   * @returns {AxiosPromise<any>}
   */
  setTariff(data: SetTarif): AxiosPromise<any> {
    return axios().request({
      url: URLS().cloudUrlSetTariff,
      method: 'post',
      data,
    });
  },

};
